// extracted by mini-css-extract-plugin
export default {"item":"menu-item_item__X+dfg"};